import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, TextInput } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

const ValidateRequired = required();

const styles = createStyles({
  half_length: {
    width: '50%'
  }
});

type Props = {
  classes: any
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name="active" source="active" component={BooleanInput} label="Active" style={{ width: '0' }} /><br />
    <Field name="name" source="name" component={TextInput} label="Name *" validate={ValidateRequired} className={props.classes.half_length} /><br />
    <Field name="seat_id" source="seat_id" component={TextInput} label="Seat Id" className={props.classes.half_length} /><br />
    <Field name="wseat" source="wseat" component={TextInput} label="WSeat" className={props.classes.half_length} />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Networks/Partials/SettingsTab.tsx